<template>
    <div class="mt-5 mb-5">
        <BOverlay :show="is_loading">
            <div ref="pos_items" id="positions_item" style="height:600px"></div>
            <input
                ref="xlsfile"
                type="file"
                accept=".xls,.xlsx"
                hidden
                @change="onExcelSelected"
            />
        </BOverlay>
    </div>
    
    
    <div class="row">
        <div class="col-xl-9 col-lg-9 col-sm-8 col-xs-12">
            <div class="container-fluid">
                <div class="row height38">
                    <div class="col-2">Cума без ПДВ:</div>
                    
                    <div class="summ_app col-3">{{ fmtUA(totals.sumUAH) }} грн.</div>
                    
                    <div class="col-sm-3">
                        <input
                            :disabled="only_view"
                            @change="calcParamsByPdv"
                            type="radio"
                            value="1"
                            v-model="request.has_pdv" /> ПДВ 20%
                    </div>
                
                
                </div>
                
                <div class="row height38">
                    <div class="col-2">ПДВ:</div>
                    <div class="pdv_app col-3">{{ fmtUA(totals.pdv) }} грн.</div>
                    
                    <div class="col-sm-3">
                        <input
                            :disabled="only_view"
                            @change="calcParamsByPdv"
                            type="radio"
                            value="2"
                            v-model="request.has_pdv" /> ПДВ 14%
                    </div>
                    
                </div>
                
                <div class="row height38">
                    <div class="col-2">Cума з ПДВ:</div>
                    <div class="summ_pdv_app col-3">{{ fmtUA(totals.total) }} грн.</div>
                    <div class="col-sm-3">
                        <input
                            :disabled="only_view"
                            @change="calcParamsByPdv"
                            type="radio"
                            value="3"
                            v-model="request.has_pdv" /> ПДВ 7%
                    </div>
                </div>
                
                <div class="row height38">
                    <div class="col-2"></div>
                    <div class="summ_pdv_app col-3">{{ fmtUA(totals.total) }}</div>
                    <div class="col-sm-3">
                        <input
                            :disabled="only_view"
                            @change="calcParamsByPdv"
                            type="radio"
                            value="0"
                            v-model="request.has_pdv" /> Не платник ПДВ
                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-xl-3 col-lg-3 col-sm-4 col-xs-12">
            <div class="eur_exchange_rate pb-3" v-show="showUsd">
                <div class="form-group">
                    <label class="form-label" for="usd">Курс USD *:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">$</span>
                        </div>
                        
                        <input @change="calcParamsByPdv"
                               type="number"
                               step="0.01" min="0" max="100" class="form-control" v-model="usdRate" />
                    </div>
                </div>
            </div>
            
            <div class="eur_exchange_rate pb-3 " v-show="showEur">
                <div class="form-group">
                    <label class="form-label" for="euro">Курс EUR *:</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">€</span>
                        </div>
                        <input @change="calcParamsByPdv"
                               type="number" step="0.01"
                               min="0" max="100"
                               class="form-control" v-model="eurRate" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <tender_files_add :only_view="only_view" :tender="tender"></tender_files_add>
    
    
    <div class="buttons" v-if="!user.guest && !only_view">
        <div class="btn btn-outline-success btn-ok btn_save_send_confirm mr-2" v-if="can_send"
             v-on:click="sendForConfirm">
            Подати заявку
        </div>
        
        <div class="btn btn-warning btn_save" v-on:click="sendDraft">Зберегти чернетку</div>
    </div>
    
</template>

<script>
import * as W2 from 'w2ui'
import { mapGetters } from "vuex";
import {
    BTable,
    BOverlay
} from 'bootstrap-vue-next';

import tender_files_add from "../request/tender_files_add.vue";

window.w2ui    = W2.w2ui
window.w2grid  = W2.w2grid
window.w2field = W2.w2field
window.query   = W2.query
window.w2utils = W2.w2utils

const num = v => Number.parseFloat(v) || 0;
const round2 = v => Math.round(num(v) * 100) / 100;
const mul2 = (a, b) => round2(num(a) * num(b));
const div2 = (a, b) => (num(b) === 0 ? 0 : round2(num(a) / num(b)));

export default {
    name: "tender_position",
    
    props: {
        tender: {
            type: Object,
            required: true
        },
        only_view: {
            type: Boolean,
            default: false,
        },
    },
    
    components: {
        tender_files_add,
        BOverlay
    },
    
    data() {
        return {
            is_loading: false,
            columns: [],
            positions: [],
            currencies: [],
            
            showUsd: false,
            showEur: false,
            
            totals: { sumUAH: 0, pdv: 0, total: 0 },
        }
    },
    
    created() {
        this.initW2ui();
    },
    
    methods: {
        normalizeDecimalInput(value) {
            let s = String(value ?? '');
            
            s = s.replace(/\s+/g, '');
            s = s.replace(/,/g, '.');
            s = s.replace(/[^0-9.]/g, '');
            
            const firstDot = s.indexOf('.');
            if (firstDot !== -1) {
                s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '');
            }
            
            return s;
        },
        
        toNum(value) {
            const s = this.normalizeDecimalInput(value);
            return s === '' ? 0 : Number(s);
        },
        
        getColIndex(field) {
            return this.columns.findIndex(c => (c.field || c.name) === field);
        },
        
        async sendApplication(is_draft = false) {
            IMC_CORE.showloading();
            
            await this.save_req(is_draft).then(({ data }) => {
                IMC_CORE.hideloading();
                IMC_CORE.snackbar('Збережено');
                EventBus.$emit('reload_app');
                
                if (parseInt(this.tender.app_id) === 0) {
                    window.location.href = "/applications";
                }
            }).catch(({ response }) => {
                IMC_CORE.hideloading();
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                });
            });
        },
        
        async save_req(is_draft) {
            return api.put(
                '/tenders/contragent/tenders/' + parseInt(this.tender.id) + "/applications/" + this.tender.app_id,
                {
                    tender: this.tender,
                    positions: w2ui.positions?.records || this.positions,
                    rate: {
                        usdRate: this.usdRate,
                        eurRate: this.eurRate,
                    },
                    is_draft: is_draft
                }
            );
        },
        
        sendForConfirm() {
            confirm_imc('Подати заявку?').then(() => {
                this.sendApplication(false);
            });
        },
        
        sendDraft() {
            this.sendApplication(true);
        },
        
        async initW2ui() {
            try {
                const { data } = await api.get('/tenders/list/applications/columns?view_mode=new');
                
                if (data.status === "operation_success") {
                    this.columns = (data.data || []).map(col => {
                        if (['price', 'summ', 'quantity_app'].includes(col.field)) {
                            col.editable = { type: 'text' };
                        }
                        return col;
                    });
                    
                    this.currencies = data.message || [];
                    this.initCurrency();
                    this.initGrid();
                }
            } catch (e) {
                console.error(e);
                EventBus.$emit('show_toast', {
                    err: e.response?.data?.message || e.message,
                    type: "danger",
                    title: "error"
                });
            }
        },
        
        initCurrency() {
            const currencyItems = (this.currencies || []).map(i => ({
                id: String(i.id),
                text: String(i.text || i.title || '')
            }));
            
            const curIdx = this.getColIndex('currency_id');
            if (curIdx === -1) return;
            
            const col = this.columns[curIdx];
            col.editable = { type: 'select', items: currencyItems, showAll: true };
            
            col.render = function (record, index, col_index) {
                const val = String(record?.w2ui?.changes?.currency_id ?? record?.currency_id ?? '');
                const it = (this.columns[col_index].editable.items || []).find(x => String(x.id) === val);
                return it ? it.text : '';
            };
        },
        
        initGrid() {
            if (w2ui['positions']) w2ui['positions'].destroy();
            this.fixNumber();
            
            $('#positions_item').w2grid({
                name: 'positions',
                show: {
                    lineNumbers: true,
                    toolbar: true,
                    footer: true
                },
                columns: this.columns,
                records: [],
                toolbar: this.addTollBar()
            });
            
            this.bindEvents();
            this.loadPositions();
        },
        
        fixNumber() {
            if (window.w2utils && w2utils.formatNumber) {
                const orig = w2utils.formatNumber;
                w2utils.formatNumber = function(val, fraction, useGrouping) {
                    if (useGrouping !== true && useGrouping !== false) {
                        useGrouping = false;
                    }
                    return orig.call(this, val, fraction, useGrouping);
                };
            }
        },
        
        addTollBar() {
            return {
                items: this.toolBar,
                onClick: (event) => {
                    if (event.target === 'btn_import_xls_menu') this.importExcel();
                    if (event.target === 'btn_save_xls_menu') this.exportExcel();
                    if (event.target.startsWith('valute:')) {
                        this.changeCurrency(event.target.split(':')[1]);
                    }
                }
            }
        },
        
        bindEvents() {
            const self = this;
            
            const quantityColIndex = this.getColIndex('quantity');
            const quantityAppColIndex = this.getColIndex('quantity_app');
            const priceColIndex = this.getColIndex('price');
            const summColIndex = this.getColIndex('summ');
            
            w2ui.positions.on("change", function (event) {
                if (self.only_view) {
                    event.preventDefault();
                    return;
                }
                
                const grid = this;
                
                event.onComplete = function () {
                    const totalQty = self.toNum(grid.getCellValue(event.index, quantityColIndex));
                    const qtyApp = self.toNum(grid.getCellValue(event.index, quantityAppColIndex));
                    const price = self.toNum(grid.getCellValue(event.index, priceColIndex));
                    const newVal = self.toNum(event.value_new);
                    
                    if (event.column === priceColIndex) {
                        grid.set(event.recid, {
                            price: newVal,
                            summ: mul2(newVal, qtyApp)
                        });
                    }
                    else if (event.column === summColIndex) {
                        grid.set(event.recid, {
                            summ: newVal,
                            price: div2(newVal, qtyApp || 1)
                        });
                    }
                    else if (event.column === quantityAppColIndex) {
                        if (newVal > totalQty) {
                            EventBus.$emit('show_toast', {
                                err: 'Кількість (наявність) не може бути більшою за загальну кількість',
                                type: "danger",
                                title: "error"
                            });
                            
                            grid.set(event.recid, {
                                quantity_app: totalQty,
                                summ: mul2(totalQty, price)
                            });
                        } else {
                            grid.set(event.recid, {
                                quantity_app: newVal,
                                summ: mul2(newVal, price)
                            });
                        }
                    }
                    else if (event.column === this.columns.findIndex(c => c.field === 'currency_id')) {
                        // просто пересчет итогов при смене валюты
                    }
                    else {
                        return;
                    }
                    
                    grid.refreshRow(event.recid);
                    grid.save();
                    self.calcParams();
                };
            });
            
            w2ui.positions.on("editField", function (event) {
                event.onComplete = function () {
                    const input = event.input?.selector ? $(event.input.selector) : null;
                    if (!input || !input.length) return;
                    
                    input
                        .attr('inputmode', 'decimal')
                        .off('.decimalFix')
                        .on('input.decimalFix', function () {
                            const start = this.selectionStart ?? this.value.length;
                            const oldValue = this.value;
                            
                            this.value = self.normalizeDecimalInput(this.value);
                            
                            const diff = oldValue.length - this.value.length;
                            const pos = Math.max(0, start - diff);
                            
                            try {
                                this.setSelectionRange(pos, pos);
                            } catch (e) {}
                        })
                        .on('paste.decimalFix', function () {
                            setTimeout(() => {
                                this.value = self.normalizeDecimalInput(this.value);
                            }, 0);
                        })
                        .on('blur.decimalFix', function () {
                            this.value = self.normalizeDecimalInput(this.value);
                        });
                };
            });
        },
        
        changeCurrency(selectedId) {
            const grid = w2ui['positions'];
            const val = String(selectedId);
            
            grid.records.forEach(r => {
                r.currency_id = val;
                if (r.w2ui?.changes) {
                    r.w2ui.changes.currency_id = val;
                }
            });
            
            grid.refresh();
            this.calcParams();
        },
        
        exportExcel() {
            const ten_id = this.tender.id;
            window.open(`/internal/application/export_excel?ten_id=${ten_id}`, '_blank');
        },
        
        importExcel() {
            this.$refs.xlsfile?.click();
        },
        
        async onExcelSelected(e) {
            const file = e.target.files?.[0];
            e.target.value = '';
            
            if (!file) return;
            
            const form = new FormData();
            form.append('file', file);
            form.append('ten_id', String(this.tender.id));
            form.append('id', String(this.tender.app_id));
            
            const { data } = await axios.post('/internal/application/import_excel', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            
            const rows = Array.isArray(data?.data) ? data.data : JSON.parse(data?.data || '[]');
            
            if (!Array.isArray(rows) || rows.length === 0) {
                IMC_CORE.hideloading();
                IMC_CORE.snackbar('Файл завантажений, але даних не знайдено');
                return;
            }
            
            this.applyExcelRows(rows);
            IMC_CORE.hideloading();
            IMC_CORE.snackbar('Імпортовано з XLS');
        },
        
        applyExcelRows(rows) {
            const grid = w2ui.positions;
            if (!grid) return;
            
            const byPos = new Map();
            for (const r of grid.records) {
                byPos.set(String(r.position_id), r.recid);
            }
            
            const qtyAppColIndex = this.getColIndex('quantity_app');
            
            for (const x of rows) {
                const posId = String(x.position_id ?? '');
                const recid = byPos.get(posId);
                if (!recid) continue;
                
                const recIndex = grid.get(recid, true);
                const qtyApp = this.toNum(grid.getCellValue(recIndex, qtyAppColIndex));
                const price = this.toNum(x.price);
                
                grid.set(recid, {
                    price,
                    summ: +(price * qtyApp).toFixed(2),
                    comment: String(x.comment ?? '')
                });
            }
            
            grid.refresh();
            this.calcParams();
        },
        
        calcParams() {
            this.syncFromGrid();
            this.recalcTotals();
        },
        
        calcParamsByPdv() {
            this.calcParams();
        },
        
        syncFromGrid() {
            const recs = w2ui.positions?.records || [];
            
            const curIds = recs.map(r =>
                String(r?.w2ui?.changes?.currency_id ?? r.currency_id ?? '1')
            );
            
            this.showUsd = curIds.includes('2');
            this.showEur = curIds.includes('3');
        },
        
        recalcTotals() {
            const records = w2ui.positions?.records || [];
            
            const rateFor = (curId) => {
                const id = String(curId ?? '1');
                if (id === '2') return Number(this.usdRate) || 0;
                if (id === '3') return Number(this.eurRate) || 0;
                return 1;
            };
            
            let sumUAH = 0;
            
            for (const r of records) {
                const summ = Number(r?.w2ui?.changes?.summ ?? r.summ) || 0;
                const currencyId = r?.w2ui?.changes?.currency_id ?? r.currency_id ?? '1';
                
                if (!summ) continue;
                sumUAH += summ * rateFor(currencyId);
            }
            
            let pdvRate = 0;
            if (parseInt(this.pdvType) === 1) pdvRate = 0.20;
            else if (parseInt(this.pdvType) === 2) pdvRate = 0.14;
            else if (parseInt(this.pdvType) === 3) pdvRate = 0.07;
            
            const pdv = sumUAH * pdvRate;
            const total = sumUAH + pdv;
            
            this.totals = {
                sumUAH: round2(sumUAH),
                pdv: round2(pdv),
                total: round2(total),
            };
        },
        
        async loadPositions() {
            this.is_loading = true;
            
            await api.get('/tenders/list/' + this.tender.id + '/applications/' + this.tender.app_id + '/positions')
                .then(({ data }) => {
                    this.is_loading = false;
                    
                    if (data.status === "operation_success") {
                        this.positions = data.data || [];
                        w2ui.positions.records = this.positions;
                        w2ui.positions.refresh();
                        this.calcParams();
                    }
                })
                .catch(response => {
                    this.is_loading = false;
                    console.log(response);
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    });
                });
        },
        
        fmtUA(v) {
            return (Math.round((Number(v) || 0) * 100) / 100)
                .toLocaleString('uk-UA', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });
        },
    },
    
    computed: {
        ...mapGetters({
            'user': "user/getUser",
        }),
        
        customer_verified() {
            return this.user?.settings?.verifed || -1;
        },
        
        can_send() {
            return parseInt(this.customer_verified) != -1;
        },
        
        request() {
            return this.tender.request;
        },
        
        pdvType() {
            return this.request.has_pdv;
        },
        
        usdRate: {
            get() {
                return this.request.usd_exchange_rate;
            },
            set(val) {
                this.request.usd_exchange_rate = Number(val) || 0;
            }
        },
        
        eurRate: {
            get() {
                return this.request.eur_exchange_rate;
            },
            set(val) {
                this.request.eur_exchange_rate = Number(val) || 0;
            }
        },
        
        toolBar() {
            if (this.only_view) {
                return [];
            }
            
            return [
                { type: 'break' },
                {
                    type: 'html',
                    id: 'lbl_currency',
                    html: '<div style="padding:3px 10px;">Змінити валюту на:</div>'
                },
                {
                    type: 'menu-radio',
                    id: 'valute',
                    icon: 'fa fa-star',
                    text(item) {
                        const el = this.get('valute:' + item.selected);
                        return ' ' + (el ? el.text : '');
                    },
                    selected: '0',
                    items: this.currencies
                },
                {
                    type: 'button',
                    id: 'btn_save_xls_menu',
                    text: '[Зберегти шаблон в XLS]',
                    style: 'color:green; font-weight:bold;'
                },
                {
                    type: 'button',
                    id: 'btn_import_xls_menu',
                    text: '[Завантажити з XLS]',
                    style: 'color:green; font-weight:bold;'
                }
            ];
        },
    }
}
</script>



<style scoped>
.height38 {
    min-height: 43px;
    padding-top: 5px;
}
</style>